import { useEffect, useState } from "react";
import { generate_id, info_device, translateWord } from "../../../Util/util";

export default function HelpInfo({ configs }) {
    let software_version = '';

    try {
        software_version = process.env.REACT_APP_VERSION || 'No Version'

    } catch (e) {
        software_version = 'No Version'

    }

    const [deviceInfo, setDeviceInfo] = useState('')
    const [language, setLanguage] = useState('')

    useEffect(() => {
        setDeviceInfo(info_device())
        if (localStorage.getItem('language') && localStorage.getItem('language') != 'null') {
            setLanguage(JSON.parse(localStorage.getItem('language')).name)
        } else {
            setLanguage('English')
        }
    }, [])
    return (
        <div className={'main_help_info'}>
            <h2>
                <span className="title_help_info">{translateWord('Software Version')}</span>
                <span className="value_help_info">{software_version}</span>
            </h2>
            <h2>
                <span className="title_help_info">{translateWord('Device Model')}</span>
                <span className="value_help_info">{deviceInfo}</span>
            </h2>
            <h2>
                <span className="title_help_info">{translateWord('App Language')}</span>
                <span className="value_help_info">{language}</span>
            </h2>

            <h3 className="main_title_help_info">{translateWord('If you need help')}</h3>
            <h4 className="main_value_help_info">{translateWord('Please go to')} “<a href={configs && configs.help_page && configs.help_page != 'null' ? configs.help_page.replace("{{lang}}", configs.language.iso_code) : '#'}>{configs && configs.help_page && configs.help_page != 'null' ? configs.help_page.replace("{{lang}}", configs.language.iso_code) : ''}</a>”</h4>
            <h3 className="main_title_help_info">{translateWord('Do you want to contact us')}?</h3>
            <h4 className="main_value_help_info">{translateWord('Please call')} {configs ? configs.contact_number : ''}</h4>
        </div>
    )
}